// Bengali translations
export const bn: Record<string, string> = {
  'menu.dashboard': 'ড্যাশবোর্ড', 'menu.orderNew': 'পণ্য নিবন্ধন', 'menu.customers': 'গ্রাহক', 'menu.products': 'পণ্য', 'menu.users': 'ব্যবহারকারী', 'menu.settings': 'সেটিংস', 'menu.logout': 'লগ আউট',
  'dashboard.title': 'ড্যাশবোর্ড', 'dashboard.todaySales': 'আজকের বিক্রয়', 'dashboard.totalOrders': 'মোট অর্ডার', 'dashboard.newOrder': 'নতুন অর্ডার', 'dashboard.newCustomer': 'নতুন গ্রাহক',
  'order.title': 'নতুন অর্ডার', 'order.customer': 'গ্রাহক', 'order.products': 'পণ্য', 'order.quantity': 'পরিমাণ', 'order.price': 'মূল্য', 'order.total': 'মোট', 'order.payment': 'পেমেন্ট', 'order.cash': 'নগদ', 'order.card': 'কার্ড',
  'users.title': 'ব্যবহারকারী', 'users.name': 'নাম', 'users.email': 'ইমেল', 'users.role': 'ভূমিকা', 'users.edit': 'সম্পাদনা', 'users.delete': 'মুছুন',
  'common.yes': 'হ্যাঁ', 'common.no': 'না', 'common.cancel': 'বাতিল', 'common.save': 'সংরক্ষণ', 'common.search': 'অনুসন্ধান', 'common.loading': 'লোড হচ্ছে...',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy', 'login.login': 'লগইন', 'login.enterPin': 'পিন লিখুন', 'login.welcome': '&X',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.title': 'নিবন্ধন', 'signup.createAccount': 'অ্যাকাউন্ট তৈরি করুন', 'signup.email': 'ইমেল', 'signup.phone': 'ফোন',
  'menu.reportsAndAccounting': 'রিপোর্ট ও হিসাব',
  'menu.systemAndCommunication': 'সিস্টেম ও যোগাযোগ',
};
